import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"filter\">\n  <path d=\"M0 6.759h32v3.225h-32v-3.225zM6.3 22.016h19.403v3.225h-19.403v-3.225zM3.15 14.387h25.703v3.225h-25.703v-3.225z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol